import { useState } from 'react'

export type ViewMode = 'editor' | 'split' | 'preview'

function readPersisted<T>(name: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(name)
    return raw === null ? fallback : JSON.parse(raw) as T
  }
  catch {
    return fallback
  }
}

function writePersisted<T>(name: string, value: T) {
  try {
    localStorage.setItem(name, JSON.stringify(value))
  }
  catch {
    // ignore (e.g. storage disabled)
  }
}

export function useViewStore() {
  const [viewModeValue, setViewModeValue] = useState<ViewMode>(() => readPersisted('tiptap-view-mode', 'editor'))
  const [sourceModeValue, setSourceModeValue] = useState<boolean>(() => readPersisted('tiptap-source-mode', false))
  const [fullscreen, setFullscreen] = useState(false)

  function setViewMode(mode: ViewMode) {
    setViewModeValue(mode)
    writePersisted('tiptap-view-mode', mode)
  }

  function toggleSourceMode() {
    setSourceModeValue((v) => {
      const next = !v
      writePersisted('tiptap-source-mode', next)
      return next
    })
  }

  return {
    viewMode: viewModeValue,
    setViewMode,
    sourceMode: sourceModeValue,
    toggleSourceMode,
    fullscreen,
    toggleFullscreen: () => setFullscreen(v => !v),
  }
}
